import { useSelector } from 'react-redux'
import styles from './Toggle.module.scss'
import { selectDarkTheme } from '../../../store/slices/settingsSlice'

type Props = {
  onChange: () => void
  checked?: boolean
  disabled?: boolean
  value?: string
  id: string
}

export const Toggle = ({ checked, disabled, onChange, value = '', id }: Props) => {
  const darkTheme = useSelector(selectDarkTheme)

  const toggleClasses = [
    styles.toggle,
    disabled && styles.disabled,
    darkTheme && styles.dark
  ].filter(Boolean).join(' ')

  return (
    <div className={toggleClasses}>
      <input
        disabled={disabled}
        type="checkbox"
        checked={checked}
        id={id}
        value={value}
        onChange={onChange}
      />
      <label htmlFor={id}></label>
    </div>
  )
}